import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#EA1C0A',
        },
        secondary: {
            main: '#0035ff',
        },
        background: {
            default: '#ffffff',
            paper: '#cbeaea',
        },
    },
});

export const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#f48fb1',
        },
        secondary: {
            main: '#899eff',
        },
        background: {
            default: '#1e1e1e',
            paper: '#1e1e1e',
        },
    },
});
